import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  multiText: [{
    text: '₹30 off ',
    isBold: true,
    type: 'body-single-line-sm'
  }, {
    text: 'on recharge ',
    isBold: false,
    type: 'body-single-line-sm'
  }, {
    text: 'above ₹200',
    isBold: true,
    type: 'body-single-line-sm'
  }],
  actionType: 'button',
  iconName: 'CouponIcon',
  actionTypeProps: {
    iconName: 'RightChevronButtonIcon',
    buttonText: 'Apply'
  }
}, getTestId('OfferContextualStripWidgetContainer'));